export default {
  my_points: 'My points',
  loyalty_points: 'Loyalty points',
  already_have_points: 'Do you already have points?',
  log_in: 'Log in',
  description: '🔥 Earn {{percentage}}p for every {{amount}} spent',
  buttons: {
    sign_in_sign_up: 'Sign In/ Sign Up',
    sign_in: 'Sign In',
  },
  points: {
    label: 'Join {{company}} Rewards! Get a {{reward}} reward for every {{spend}} spent. ',
  },
};
